// extracted by mini-css-extract-plugin
module.exports = {"logoWrapper":"logo-marquee_logoWrapper__ZBPzE","illustration":"logo-marquee_illustration__w53_Q","logos":"logo-marquee_logos__XISG4"};